var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.order.items && _vm.order.items.length)?_c('Button',{staticClass:"mt-2 mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-cart")]),_vm._v("Checkout")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }